import { IconDevices } from "@tabler/icons-react"
import { DeviceCard } from "./device-card"
import type { Device } from "@/types/device"

interface DeviceListProps {
  devices: Device[]
}

export function DeviceList({ devices }: DeviceListProps) {
  if (devices.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <IconDevices className="size-12 text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold">No devices yet</h3>
        <p className="text-muted-foreground text-sm mt-1">
          Add your first Tilt Hydrometer to start monitoring
        </p>
      </div>
    )
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {devices.map((device) => (
        <DeviceCard key={device.id} device={device} />
      ))}
    </div>
  )
}
